import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment-timezone';
// import moment from 'moment';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';

//containers
import AuthUserContainer from '../../../containers/AuthUser';
import PtoRequestContainer from '../../../containers/PtoRequest';

//- UI / Form
import Grid from '@material-ui/core/Grid';
import FormContainer from '../../../components/FormContainer';
//import SectionHeader from '../../../components/SectionHeader';
import FormComponent from '../../../components/FormComponent';
import { getGlobalClasses } from '../../../themes';
import Note from '../../../components/Note';
import { Button } from '@material-ui/core';
// import FormTextArea from '../../../components/form/FormTextArea';
import ViewBody from '../ViewBody';
import DenyOrCancelPtoRequest from '../../../components/dialogs/DenyOrCancelPtoRequest';
import RequestActivity from '../RequestActivity';
import { post } from '../../../modules/utility';

const DWP_USER_ID = 1;
const MARY_ANN_USER_ID = 418;
const ERIKM_USER_ID = 1096;
const CLAUDIA_USER_ID = 879;
const HR_USER_IDS = [DWP_USER_ID, MARY_ANN_USER_ID, ERIKM_USER_ID, CLAUDIA_USER_ID];

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		deleteButton: {
			verticalAlign: 'middle',
			padding: '8px 10px',
		},
		addGroupButton: {
			borderRadius: '100px',
			fontSize: 16,
		},
		groupContainer: {
			borderLeft: '4px solid #ddd',
			marginLeft: 10,
			paddingLeft: 5,
			marginBottom: 20,
		},
		totalSection: {
			fontSize: 26,
			padding: 20,
			border: '1px solid #3faff5',
			margin: 10,
		},
		updateTotalSection: {
			fontSize: 20,
			border: '1px solid #3faff5',
			padding: 20,
			margin: 10,
		},
		addButton: {
			//verticalAlign : 'middle',
			//textDecoration: 'none',
			//marginBottom: 0,
			//borderRadius: 100,
			color: 'white',
			marginRight: 10,
			marginTop: 30,
			fontSize: 16,
			borderRadius: '100px',
			padding: '15px 30px',
			textTransform: 'uppercase',
		},
		cancelButton: {
			marginRight: 10,
			marginTop: 30,
			fontSize: 16,
			borderRadius: '100px',
			padding: '15px 30px',
			textTransform: 'uppercase',
		},
		currentStatus: {},
		statusRow: {
			padding: 7,
		},
	};
};

const idField = 'ptoRequestId';

class SavePtoRequest extends FormComponent {
	constructor(props) {
		super(props);

		const action = _.get(this.props, 'match.params.action');
		const id = parseInt(_.get(this.props, `match.params.${idField}`), 10);
		const isUpdate = action === 'update';

		this.requiredPathMap = {};

		// noinspection JSUnresolvedFunction
		this.state = {
			isUpdate,
			[idField]: id,
			formFieldError: {},
			isDenyDialogOpen: false,
			updateToStatus: '',
			isFetchingWorkDays: true,
			shouldShowPToScheduleSection: false,
			dateAndHours: [
				{
					date: '',
					hours: '',
				},
			],
		};
	}
	componentDidMount() {
		const { ptoRequest, getPtoRequest } = this.props;
		const { ptoRequestId } = this.state;

		if (!ptoRequest) {
			getPtoRequest({
				params: { ptoRequestIds: [ptoRequestId] },
			});
		} else {
			this.checkForExistingPtoOnSchedule({ ptoRequest });
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const { ptoRequest } = this.props;

		if (ptoRequest && ptoRequest !== prevProps.ptoRequest) {
			this.checkForExistingPtoOnSchedule({ ptoRequest });
		}
	}

	checkForExistingPtoOnSchedule = ({ ptoRequest }) => {
		const { showErrors, userMap } = this.props;
		const { requestedForUserId, dateAndHours, paidType } = ptoRequest;

		const isCashOut = paidType === 'ptoCashOut';

		const requestor = userMap[requestedForUserId] || { firstName: 'Unknown requested.' };
		if (!requestor.role || requestor.role !== 'driver') {
			console.log('Not driver. Skipping looking up schedule.');
			return;
		}

		if (isCashOut) {
			console.log('Cash out skipping looking up schedule.');
			return;
		}

		this.setState({
			shouldShowPToScheduleSection: true,
			isFetchingWorkDays: true,
		});

		post({
			method: 'workDay.searchForPtoShifts',
			params: {
				ptoRequestUserId: requestedForUserId,
				ptoRequestDates: !_.isEmpty(dateAndHours) ? _.map(dateAndHours, 'date') : [],
			},
			callback: (err, searchForPtoShiftsApiResults) => {
				if (err) {
					return showErrors(err);
				}
				setTimeout(() => {
					this.setState({
						isFetchingWorkDays: false,
						searchForPtoShiftsApiResults,
					});
				}, 500);
			},
		});
	};

	approvePtoRequest = (p = {}) => {
		const { addToSchedule } = p;
		const { updatePtoRequest, ptoRequest } = this.props;

		const { status, ptoRequestId } = ptoRequest;

		const isWaitingForSupervisorApproval = status === 'pendingSupervisorApproval';
		const isWaitingForHrApproval = status === 'pendingHrApproval';

		let action;
		if (isWaitingForSupervisorApproval) {
			action = 'supervisorApproval';
		} else if (isWaitingForHrApproval) {
			action = 'hrApproval';
		}

		updatePtoRequest({
			params: {
				ptoRequestId,
				action,
				addToSchedule,
			},
		});
	};

	denyPtoRequest = () => {
		const { updatePtoRequest, ptoRequest, showErrors } = this.props;
		const { note } = this.state;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});
		if (!note) {
			formFieldError.note = 'A note is required when denying a PTO request.';
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		updatePtoRequest({
			params: {
				ptoRequestId: ptoRequest.ptoRequestId,
				action: 'supervisorDeny',
			},
		});
	};

	cancelPtoRequest = () => {
		const { updatePtoRequest, ptoRequest, showErrors } = this.props;
		const { note } = this.state;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});
		if (!note) {
			formFieldError.note = 'A note is required when cancelling a PTO request.';
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		updatePtoRequest({
			params: {
				ptoRequestId: ptoRequest.ptoRequestId,
				action: 'supervisorCancel',
			},
		});
	};

	renderStatus = () => {
		const { ptoRequest, classes, userMap } = this.props;

		if (!ptoRequest) {
			return;
		}
		const {
			status,
			requestedForUserId,
			assignedToSupervisorUserId,
			assignedToHrUserId,
		} = ptoRequest;

		const requestor = userMap[requestedForUserId] || { firstName: 'Unknown requested.' };
		const supervisor = userMap[assignedToSupervisorUserId] || { firstName: 'Not assigned yet.' };
		const hr = userMap[assignedToHrUserId] || { firstName: 'Not assigned yet.' };

		return (
			<Grid item xs={12}>
				<Note type="info">
					<div className={classes.statusRow}>
						<strong>Requested for:</strong> {requestor.firstName} {requestor.lastName}
					</div>
					<div className={classes.statusRow}>
						<strong>Assigned to Supervisor:</strong> {supervisor.firstName} {supervisor.lastName}
					</div>
					<div className={classes.statusRow}>
						<strong>Assigned to HR:</strong> {hr.firstName} {hr.lastName}
					</div>
					<div className={classes.statusRow}>
						<strong>Current Status:</strong> {_.startCase(status).replace('Hr ', 'HR ')}
					</div>
				</Note>
			</Grid>
		);
	};

	handleCloseDenyDialog = () => {
		this.setState({
			isDenyDialogOpen: false,
			updateToStatus: '',
		});
	};

	afterDenyOrCancelPtoRequest = () => {
		console.log('LETS REDIRECT');
	};

	renderUpdateOptions = () => {
		const { authUser, ptoRequest, classes } = this.props;
		const { isSaving } = this.state;

		if (!ptoRequest) {
			return;
		}
		const { status, assignedToSupervisorUserId, assignedToHrUserId } = ptoRequest;

		//const isRequestor = authUser.userId === requestedForUserId;

		const isSupervisor = authUser.userId === assignedToSupervisorUserId;
		const isWaitingForSupervisorApproval = status === 'pendingSupervisorApproval';
		const isHr = authUser.userId === assignedToHrUserId || _.includes(HR_USER_IDS, authUser.userId);
		const isWaitingForHrApproval = status === 'pendingHrApproval';

		if (isWaitingForSupervisorApproval) {
		}

		if ((isSupervisor && isWaitingForSupervisorApproval) || (isHr && isWaitingForHrApproval)) {
			return (
				<>
					<Grid item xs={12}>
						{isWaitingForSupervisorApproval && (
							<div style={{ margin: 20, padding: 20, border: '1px solid #ddd' }}>
								<strong>Note: </strong> Confirming this PTO will automatically add it to the
								schedule for any drivers.
							</div>
						)}

						<div style={{ display: 'flex' }}>
							{isWaitingForSupervisorApproval && (
								<Button
									variant="contained"
									color="primary"
									className={classes.addButton}
									onClick={() => {
										this.approvePtoRequest({ addToSchedule: true });
									}}
									disabled={isSaving}
								>
									Approve PTO Request
								</Button>
							)}

							{!isWaitingForSupervisorApproval && (
								<Button
									variant="contained"
									color="primary"
									className={classes.addButton}
									onClick={this.approvePtoRequest}
									disabled={isSaving}
								>
									Approve PTO Request
								</Button>
							)}

							<Button
								variant="contained"
								color="secondary"
								className={classes.addButton}
								onClick={() => {
									this.setState({
										updateToStatus: 'deny',
										isDenyDialogOpen: true,
									});
								}}
								disabled={isSaving}
							>
								Deny PTO Request
							</Button>
							<Button
								variant="outlined"
								//color="secondary"
								className={classes.cancelButton}
								disabled={isSaving}
								onClick={() => {
									this.setState({
										updateToStatus: 'cancel',
										isDenyDialogOpen: true,
									});
								}}
							>
								Cancel PTO Request
							</Button>
						</div>
					</Grid>
				</>
			);
		} else {
			return (
				<Grid item xs={12}>
					<Note>
						<strong>Current Status : {_.startCase(status).replace('Hr ', 'HR ')}</strong>
					</Note>
				</Grid>
			);
		}
	};

	render() {
		const { ptoRequest, userMap } = this.props;
		const {
			searchForPtoShiftsApiResults,
			isFetchingWorkDays,
			shouldShowPToScheduleSection,
		} = this.state;
		const action = 'PTO Request';

		if (!ptoRequest) {
			return <div>Loading PTO request...</div>;
		}

		return (
			<>
				<FormContainer headline={`${action}`}>
					<ViewBody
						ptoRequest={ptoRequest}
						userMap={userMap}
						searchForPtoShiftsApiResults={searchForPtoShiftsApiResults}
						isFetchingWorkDays={isFetchingWorkDays}
						shouldShowPToScheduleSection={shouldShowPToScheduleSection}
					/>
					{this.renderUpdateOptions()}
					<DenyOrCancelPtoRequest
						open={this.state.isDenyDialogOpen}
						onClose={this.handleCloseDenyDialog}
						afterSave={this.afterDenyOrCancelPtoRequest}
						ptoRequestId={ptoRequest.ptoRequestId}
						updateToStatus={this.state.updateToStatus}
					/>
				</FormContainer>
				<RequestActivity ptoRequest={ptoRequest} userMap={userMap} />
			</>
		);
	}
}

SavePtoRequest.propTypes = {
	getPtoRequest: PropTypes.func.isRequired,
	addPtoRequest: PropTypes.func.isRequired,
	updatePtoRequest: PropTypes.func.isRequired,
	ptoRequest: PropTypes.object,

	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), AuthUserContainer, PtoRequestContainer])(SavePtoRequest);
